import React from 'react';
import { connect } from 'react-redux';
import { Icon } from 'ui';
import { ui } from '../../../constants/config';
import { filterUpdatePerPage } from '../../../actions/shared/index/filter';

/**
 * @prop {number} selectedValue (required)
 * @prop {function} selectCallback (required)
 */
const IndexRowsPicker = props => {
  const renderOption = option => (
    <option key={option} value={option} children={option} />
  );

  return (
    <div className="Index-rowsCount">
      <label htmlFor="per-page" className="u-showBelowMD">
        {t('common.per_page')}
      </label>
      <label htmlFor="per-page" className="u-hideBelowMD">
        {t('common.rows_per_page')}
      </label>
      <div className="SelectWithArrows">
        <select
          id="per-page"
          className="NewButton NewButton--white"
          onChange={e => props.selectCallback(e.target.value)}
          value={props.selectedValue}
          children={ui.INDEX_ROWS_PER_PAGE.map(renderOption)}
          aria-label={props.selectedValue}
        />
        <Icon aria-label="Select Arrow" name="select_arrows" />
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  selectedValue: state.filter.perPage,
});

const mapDispatchToProps = dispatch => ({
  selectCallback(count) {
    dispatch(filterUpdatePerPage(count));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(IndexRowsPicker);
